module.exports = __webpack_public_path__ + "fe66a2bf158f91ab45c05e91acdce942.svg";